import React, { Fragment } from 'react';
import Decorator from '../../../functions/decorator';
import PriceCalculator from "../../../functions/priceCalculations";
import { ToppingImage } from '../../../ui/primitives/ToppingImage';

const IncludedModifierTagButton = function(props) {
    let choice = props.choices[props.itemKey.toString()];

    let reAdd = function() {
        props.reAdd(props.itemKey);
        return false;
    }

    let exclude = function() {
        setNormal();
        props.exclude(props.itemKey);
        return false;
    }


    let isEmpty = function() {
        try {
            if(choice.quantity > 0) {
                return false;
            }
        }catch(e) {
            console.log(props);
        }
        return true;
    }

    let isNotEmpty = function() {
        return !isEmpty();
    }

    let isFirstHalf = function() {
        if(choice.quantity === 0) {
            return false;
        }
        if(choice.portion === 'first-half') {
            return true;
        }
        return false;
    }

    let isSecondHalf = function() {
        if(choice.quantity === 0) {
            return false;
        }
        if(choice.portion === 'second-half') {
            return true;
        }
        return false;
    }

    let isWhole = function() {
        if(choice.quantity === 0) {
            return false;
        }
        if(choice.portion === 'whole') {
            return true;
        }
        return false;
    }


    let setFirstHalf = function() {
        props.setFirstHalf(props.itemKey, true);
        return false;
    }

    let setSecondHalf = function() {
        props.setSecondHalf(props.itemKey, true);
        return false;
    }

    let setWhole = function() {
        props.setWhole(props.itemKey, true);
        return false;
    }

    let setExtra = function() {
        props.setExtra(props.itemKey, true);
        return false;
    }

    let setLight = function() {
        props.setLight(props.itemKey, true);
        return false;
    }

    let setNormal = function() {
        props.setNormal(props.itemKey, true);
        return false;
    }

    let showHalf = props.modifierObject.showHalf;
    let showDouble = props.modifierObject.showDouble;
    let currentPortion = props.choices[props.itemKey.toString()].portion;
    let size = props.choices[props.itemKey.toString()].size;
    let isSelected = props.isSelected;

    function calculateModifierPrice() {
        const mainItem = props.itemGroup.items[props.selectedMainItem];
        const modifierPrice = PriceCalculator.calculateModifierPriceForGivenItem(mainItem, props.modifierObject);
        return Decorator.formatCurrency(modifierPrice);
    }

    return isSelected ? (
        <div>
            <div className="row">
            <div className="col-2">
                <ToppingImage label={props.modifierObject.name} />
            </div>
            <div className="col-2">
                <h6 className={"mt-1"}>
                    <span>{size === 'extra' ? <b>Extra</b> : null} {Decorator.capitalizeFirst(props.modifierObject.name)}</span>
                </h6>
            </div>


            <div className='col-3'>
                {props.modifierObject.showHalf ? (
                    <Fragment>
                        <span onClick={setFirstHalf} className={`m-1 clickable-element larger-circle icon-left-circle ${isFirstHalf() ? 'store-fg-accent' : 'fg-light-gray-translucent'}`}></span>
                        <span onClick={setWhole} className={`m-1 clickable-element larger-circle icon-full-circle ${isWhole() ? 'store-fg-accent' : 'fg-light-gray-translucent'}`}></span>
                        <span onClick={setSecondHalf} className={`m-1 clickable-element larger-circle icon-right-circle ${isSecondHalf() ? 'store-fg-accent' : 'fg-light-gray-translucent'}`}></span>
                    </Fragment>
                ) : ''}
            </div>

            {(showDouble && isNotEmpty()) ? ( // Not empty and show double is enabled, show full selection
                <div data-role="buttongroup" className='topping-group'>
                    <button onClick={setExtra}
                            hidden={size === 'extra' || calculateModifierPrice() === '$0.00'}
                            className={`btn btn-sm ${size !== 'extra' ? 'active btn-outline' : 'btn-default'}`}>
                        <span className="text-bold">Extra ({calculateModifierPrice()})</span>
                    </button>
                    <button onClick={setNormal}
                            hidden={size === 'normal'}
                            className={`btn btn-sm ${size !== 'normal' ? 'active btn-accent' : 'btn-default'}`}>Remove Extra
                    </button>
                    <button onClick={exclude} className={`btn btn-sm ${!showDouble && `btn-accent`}`}>
                        <span className="text-bold">Remove</span>
                    </button>
                </div>
            ) : (
                <div className='col-2'>
                    <div className="row">
                        <button onClick={exclude} className={`btn btn-sm btn-accent`}>
                            <span className="text-bold">Remove</span>
                        </button>
                    </div>
                </div>
            )}
            </div>
            <hr className="p-0 m-0 mb-1"/>
        </div>
    ) : (
        <div>
            <div className={"row"}>
                <div className={"col-2"}>
                    <ToppingImage label={props.modifierObject.name} />
                </div>
                <div className={"col-2"}>
                    <h6 className={"mt-1"}>
                        <span>{Decorator.capitalizeFirst(props.modifierObject.name)}</span>
                    </h6>
                </div>
                <div className={"col-9 text-left"}>
                    <button onClick={reAdd} className={`btn btn-sm btn-accent`}>
                        <span className="text-bold">Add back</span>
                    </button>
                </div>
            </div>
            <hr className="p-0 m-0 mb-1 mt-1"/>
        </div>
    )
}
export default IncludedModifierTagButton;

/**
 * OLD OLD OLD
 *
 *
 * <div className={this.props.isSelected ? 'split-button m-3 d-inline-block' : 'd-inline-block'} onClick={this.props.isSelected ? function() {return false} : this.reAdd }>
                <button onClick={this.props.isSelected ? this.exclude : function() {return false} } type="button" className={`button drop-shadow ${this.props.isSelected ? 'accent' : 'primary'} ml-2 mr-2 mt-2 mb-2`} ><span className={this.props.isSelected ? `mif-cross` : 'mif-plus'}></span> {this.}</button>
                {   // If this is is selected and has customization options, show it
                    this.props.isSelected && (showDouble || showHalf) ? (
                <Fragment>
                    <button type="button" className="split dropdown-toggle store-page"></button>
                    <ul className="d-menu" data-role="dropdown">
                        { // Only render this fragment if we can select half portions
                            showHalf ? <Fragment>
                            {currentPortion === 'whole' ? '' : (
                                <Fragment>
                                    <li onClick={this.setWhole}><a><span className="icon-full-circle store-fg-accent" ></span>Whole</a></li>
                                    <li className="divider"></li>
                                </Fragment>
                            )}
                            {currentPortion === 'first-half' ? '' : <li onClick={this.setFirstHalf}><a><span className="icon-left-circle store-fg-accent" ></span> Only First Half</a></li>}
                            {currentPortion === 'second-half' ? '' : <li><a onClick={this.setSecondHalf}><span className="icon-right-circle store-fg-accent" ></span> Only Second Half</a></li>}
                        </Fragment> : ''
                        }
                        { // Only render this fragment if we can select extra / light
                            showDouble ?
                        <Fragment>
                            <li className="divider"></li>
                            {size === 'extra' ? '' : <li onClick={this.setExtra} ><a><span className="mif-plus"></span> 2X</a></li>}
                            {size === 'normal' ? '' : <li onClick={this.setNormal} ><a>Normal</a></li>}
                        </Fragment> : ''
                        }
                    </ul>
                </Fragment>) : ''}
            </div>
 */